import { Card, Grid, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import AnimatedNumber from "animated-number-react";
import Registration from "../../../assets/images/Registration.jpg";
import Registered from "../../../assets/images/registered.jpg";
import Placed from "../../../assets/images/placed.jpg";
import { axiosAuth } from "../../../api";

const RegisteredCandidate = () => {
  const formatValue = (value) => `${Number(value)?.toFixed(0)}`;
  const theme = useTheme();
  //States
  const [registrationCount, setRegistrationCount] = useState([]);
  const [loading, setLoading] = useState(true);

  //Methods
  const handleGetRegistrationCount = (skip) => {
    setLoading(true);
    axiosAuth
      .get("/api/Dashboards/dashboard-counts")
      .then((response) => {
        setRegistrationCount(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetRegistrationCount();
  }, []);
  return (
    <Grid
      container
      maxWidth="xl"
      sx={{ marginX: "auto", paddingY: 2, paddingX: 2 }}
    >
      <Grid
        container
        spacing={2}
        sx={{
          // background: "linear-gradient(to right,#4a7dcf 0%, #2a569f 100%)",
          // paddingX: 1,
          paddingY: 1,
        }}
      >
        <Grid align="center" item sm={4} xs={12}>
          <Card
            elevation={3}
            sx={{
              padding: 2,
              background: "linear-gradient(to right, #d6e4f9 0%, #a9c4f3 100%)",
            }}
          >
            <img src={Registration} alt="served" width="60%" />
            <Typography color="secondary" variant="h2">
              <AnimatedNumber
                value={registrationCount?.registersCandidatesCount}
                formatValue={formatValue}
                duration="1000"
              />
            </Typography>
            <HorizontalRuleIcon fontSize="large" color="primary" />
            <Typography variant="h5">Registered Candidates</Typography>
          </Card>
        </Grid>

        <Grid align="center" item sm={4} xs={12}>
          <Card
            elevation={3}
            sx={{
              padding: 2,
              background: "linear-gradient(to right, #d4f1f4 0%, #a0d9e7 100%)",
            }}
          >
            <img src={Placed} alt="served" width="70%" />
            <Typography color="secondary" variant="h2">
              <AnimatedNumber
                value={registrationCount?.unRegistersCandidatesCount}
                formatValue={formatValue}
                duration="1000"
              />
            </Typography>
            <HorizontalRuleIcon fontSize="large" color="primary" />
            <Typography variant="h5">Unregistered Candidates</Typography>
          </Card>
        </Grid>
        <Grid align="center" item sm={4} xs={12}>
          <Card
            elevation={3}
            sx={{
              padding: 2,
              background: "linear-gradient(to right, #e3d7f3 0%, #c0b2e0 100%)",
            }}
          >
            <img src={Registered} alt="served" width="38%" />
            <Typography color="secondary" variant="h2">
              <AnimatedNumber
                value={registrationCount?.employersCount}
                formatValue={formatValue}
                duration="1000"
              />
            </Typography>
            <HorizontalRuleIcon fontSize="large" color="primary" />
            <Typography variant="h5">Employers</Typography>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default RegisteredCandidate;
